import type { OrgOnboardingPartnerInfo } from './use-organization-onboarding';

// A campaign whose venues publish before adding billing information (Try for Free).
// Which campaigns these are is a backend property (`deferred_billing` in the partner
// lookup), so a new one needs no frontend change. Such a campaign skips the intro screen
// and shows its free days above the venue search.
export const isDeferredBillingCampaign = (partnerInfo?: OrgOnboardingPartnerInfo | null): boolean =>
  partnerInfo?.source_type === 'campaign' && partnerInfo.deferred_billing === true;
